import React from 'react';
import MedicalDashboard from '../components/MedicalDashboard';
import MainLayout from '../components/MainLayout';

const Dashboard = ({ onEditDoctor }) => {
  return (
    <MainLayout onEditDoctor={onEditDoctor}>
      <MedicalDashboard />
    </MainLayout>
  );
};

export default Dashboard;